import { HintMap } from '@/models/common/hint/hint-map.model';
import { DocumentHintNames } from '@/models/documents/document-hint-names.model';

export const DOCUMENT_HINT_MAP: HintMap = {
  [DocumentHintNames.TAGS]: {
    title: 'Tags',
    description: 'Enter at least two characters to start the search',
  },
  [DocumentHintNames.SEGMENTS]: {
    title: 'Segments',
    description: 'Enter at least two characters to start the search',
  },
};
